import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TeacherInfo.css";
import Sidebar from "../../SideBar/SideBar";
import ContentHeader from "../ContentHeeader/ContentHeader";
import TeacherInfo from "./TeacherInfo";
import NewsForm from "../../NewsForm/NewsForm";
import ChangePasswordForm from "../../ChangePasswordForm/ChangePasswordForm";
import NewsDisplay from "../../NewsForm/NewsDisplay";

function UserPage() {
	const [activeForm, setActiveForm] = useState("Users");
	const { logout } = useAuth();
	const navigate = useNavigate();
	const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
	const [title, setTitle] = useState("Anställd information");
	const [setDataChanged] = useState(false);
	const handleLogout = () => {
		logout();
		navigate("/login");
	};

	const handleHamburgerToggle = () => {
		setIsHamburgerOpen(!isHamburgerOpen);
	};

	const renderActiveForm = () => {
		switch (activeForm) {
			case "Users":
				return <TeacherInfo />;
			case "news":
				return <NewsForm setDataChanged={setDataChanged}/>;
			case "newsDisplay":
				return <NewsDisplay />;
			case "changePassword":
				return <ChangePasswordForm showTeacherId={false} />;
			default:
				return <div>Ogiltig åtgärd vald</div>;
		}
	};

	return (
		<div className="user-container container border mt-3 p-2">
			<Sidebar
				setActiveForm={setActiveForm}
				showLastThree={true}
				onLogout={handleLogout}
				onHamburgerToggle={handleHamburgerToggle}
				isHamburgerOpen={isHamburgerOpen}
				setIsHamburgerOpen={setIsHamburgerOpen}
				setTitle={setTitle}
			/>
			<div className="content container border p-0">
				<ContentHeader title={title} />
				<div className="p-4">{renderActiveForm()}</div>
			</div>
		</div>
	);
}

export default UserPage;
